import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface VeraConversation {
	id: number;
	user_id: number;
	title: string | null;
	created_at: string;
	updated_at: string;
}

export interface VeraMessageRecord {
	id: number;
	conversation_id: number;
	role: 'user' | 'assistant';
	message: string;
	options: Record<string, any>[] | null;
	created_at: string;
}

/** Every LMS_api response is wrapped as `{ success, body }` (see HTTP::_200 in utils/http_responses.php). */
interface ApiResponse<T> {
	success: boolean;
	body: T;
}

@Injectable({
	providedIn: 'root',
})
export class VeraConversationService {
	constructor(private http: HttpClient) {}

	listConversations(userId: number) {
		const url = `${environment.api}vera_conversations/${userId}/select_by_user`;
		return this.http.get<ApiResponse<VeraConversation[]>>(url).pipe(map((res) => res.body ?? []));
	}

	createConversation(userId: number, title: string) {
		const formData = new FormData();
		formData.append('user_id', userId.toString());
		formData.append('title', title);
		return this.http.post<ApiResponse<{ id: number }>>(`${environment.api}vera_conversations/create`, formData).pipe(map((res) => res.body));
	}

	renameConversation(conversationId: number, userId: number, title: string) {
		const formData = new FormData();
		formData.append('id', conversationId.toString());
		formData.append('user_id', userId.toString());
		formData.append('title', title);
		return this.http.post<ApiResponse<any>>(`${environment.api}vera_conversations/rename`, formData);
	}

	deleteConversation(conversationId: number, userId: number) {
		const formData = new FormData();
		formData.append('id', conversationId.toString());
		formData.append('user_id', userId.toString());
		return this.http.post<ApiResponse<any>>(`${environment.api}vera_conversations/delete`, formData);
	}

	getMessages(conversationId: number) {
		const url = `${environment.api}vera_messages/${conversationId}/select_by_conversation`;
		return this.http.get<ApiResponse<VeraMessageRecord[]>>(url).pipe(map((res) => res.body ?? []));
	}

	saveMessage(conversationId: number, userId: number, role: 'user' | 'assistant', message: string, options?: Record<string, any>[]) {
		const formData = new FormData();
		formData.append('conversation_id', conversationId.toString());
		formData.append('user_id', userId.toString());
		formData.append('role', role);
		formData.append('message', message);
		if (options?.length) {
			formData.append('options', JSON.stringify(options));
		}
		return this.http.post<ApiResponse<{ id: number }>>(`${environment.api}vera_messages/create`, formData).pipe(map((res) => res.body));
	}
}
